// extracted by mini-css-extract-plugin
module.exports = {"accept":"Accept_accept__Elt78","inner":"Accept_inner__HSXao","text":"Accept_text__v_416","mobile":"Accept_mobile__HqBCN","desktop":"Accept_desktop__mzUyg"};